import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { extractTitleTextColor, extractSummary } from '../common/primitives';
import { extractLozenge } from '../common/lozenge';
import { extractIcon } from '../common/icon';
import { extractCommentCount, extractProgrammingLanguage, extractSubscriberCount, extractAttachmentCount } from '../common/detail';
import { extractLink, extractTitle, extractProvider, extractMembers, extractPersonAssignedTo, extractPersonCreatedBy, extractPersonUpdatedBy, extractImage } from '@atlaskit/link-extractors';
import { extractByline } from '../common/byline/extractByline';
import { extractTitlePrefix } from '../common/title-prefix/extractTitlePrefix';
import { extractClientActions } from '../common/actions/extractActions';
import { extractPreviewAction } from '../common/actions/extractPreviewAction';
import { extractIsTrusted } from '../common/meta/extractIsTrusted';
var extractBlockIcon = function extractBlockIcon(jsonLd) {
  var icon = extractIcon(jsonLd);
  if (typeof icon === 'string') {
    return {
      url: icon
    };
  } else {
    return {
      icon: icon
    };
  }
};
var extractBlockDetails = function extractBlockDetails(jsonLd) {
  return [extractCommentCount(jsonLd), extractProgrammingLanguage(jsonLd), extractSubscriberCount(jsonLd), extractAttachmentCount(jsonLd)].filter(function (detail) {
    return !!detail;
  });
};
export var extractBlockActions = function extractBlockActions(props, jsonLd, opts, platform, meta) {
  if (opts) {
    var handleInvoke = opts.handleInvoke,
      actionOptions = opts.actionOptions;
    var actions = extractClientActions(jsonLd, handleInvoke, actionOptions);
    var previewAction = extractPreviewAction(_objectSpread(_objectSpread({}, opts), {}, {
      viewProps: props,
      jsonLd: jsonLd,
      platform: platform,
      meta: meta
    }));

    // The previewAction should always be the last action
    if (previewAction) {
      actions.push(previewAction);
    }
    return actions;
  }
  return [];
};
export var extractBlockUsers = function extractBlockUsers(jsonLd) {
  if (jsonLd['@type'] === 'atlassian:Project') {
    return extractMembers(jsonLd);
  } else if (jsonLd['@type'] === 'atlassian:Task') {
    var assignedMembers = extractPersonAssignedTo(jsonLd);
    if (assignedMembers) {
      return [assignedMembers];
    }
  } else if (jsonLd['@type'] === 'atlassian:SourceCodePullRequest') {
    return extractPersonCreatedBy(jsonLd);
  } else {
    var updatedBy = extractPersonUpdatedBy(jsonLd);
    var updatedByMembers;
    if (updatedBy) {
      updatedByMembers = [updatedBy];
    }
    var createdByMembers = extractPersonCreatedBy(jsonLd);
    return updatedByMembers || createdByMembers;
  }
};
export var extractBlockProps = function extractBlockProps(jsonLd, meta, opts, renderers, platform) {
  var props = {
    link: extractLink(jsonLd),
    title: extractTitle(jsonLd),
    titleTextColor: extractTitleTextColor(jsonLd),
    lozenge: extractLozenge(jsonLd),
    icon: extractBlockIcon(jsonLd),
    context: extractProvider(jsonLd),
    details: extractBlockDetails(jsonLd),
    byline: extractSummary(jsonLd) || extractByline(jsonLd),
    thumbnail: extractImage(jsonLd),
    users: extractBlockUsers(jsonLd),
    titlePrefix: extractTitlePrefix(jsonLd, renderers, 'block'),
    isTrusted: extractIsTrusted(meta)
  };
  return _objectSpread(_objectSpread({}, props), {}, {
    actions: extractBlockActions(props, jsonLd, opts, platform, meta)
  });
};